<form [formGroup]="form" novalidate (ngSubmit)="prepareForSave()">

  <h5 mat-dialog-title>Ajouter une région</h5>

  <!-- CONTENT -->
  <mat-dialog-content>
    <div class="col-12">
      <mat-label>Région :</mat-label>
      <input  type="text"
        id="inputCode"
        class="form-control w-100"
        formControlName="label"
        required
        >

        <!-- FORM MESSAGE -->
        @if (form.invalid && (label.dirty || label.touched) && this.formSubmitAttempt) {
          <p class="text-right">
            @if (label.errors.required) {
              <small class="danger text-muted">* Ce champs est requis</small>
            }
          </p>
        }
      </div>


    </mat-dialog-content>

    <!-- ACTIONS -->
    <mat-dialog-actions>

      <button mat-button type="button" [mat-dialog-close]="false">Annuler</button>
      <button mat-raised-button color="primary" type="submit">Ajouter</button>

    </mat-dialog-actions>

  </form>
